export const Header = ({ currentStep }) => {
  return currentStep === 0 ? null : (
    <p className='hidden text-text-500 text-sm font-normal xs:block'>{currentStep}/4</p>
  )
}
